export const DEFICIENCIES_COMMENT_TYPES = {
  MAINTAIN_MONITOR: 'MAINTAIN_MONITOR',
  ATTANCHENED_NEEDED: 'ATTANCHENED_NEEDED',
  ACTION_NECESSARY: 'ACTION_NECESSARY',
};
